import Editor from '@draft-js-plugins/editor';
import { EditorState } from 'draft-js';
import React from 'react';
import { convertFromHTML, convertToHTML } from 'draft-convert';

import { richButtonsPlugin, } from '../../../../../Shared/index';

class MultipleTextEditor extends React.Component {
  constructor(props) {
    super(props);

    const rbp = richButtonsPlugin();
    const {
      // inline buttons
      ItalicButton, BoldButton, UnderlineButton, BlockquoteButton
    } = rbp;

    const InlineButton = ({className, toggleInlineStyle, isActive, label, inlineStyle, onMouseDown, title}) =>
      (<button className="quill-button outlined extra-small grey focus-on-light" onClick={toggleInlineStyle} onMouseDown={onMouseDown} type="button">
        <span
          className={`${className}${isActive ? ' active' : ''}`}
          title={title ? title : label}
        >{title}
        </span>
      </button>);

    const BlockButton = ({className, toggleBlockType, isActive, label, blockType, title}) =>
      (<button className="quill-button outlined extra-small grey focus-on-light" onClick={toggleBlockType} type="button">
        <span
          className={`${className}${isActive ? ' active' : ''}`}
          title={title ? title : label}
        >{title}
        </span>
      </button>);

    this.state = {
      text: EditorState.createWithContent(convertFromHTML(this.props.text || '')),
      components: { ItalicButton, BoldButton, UnderlineButton, BlockquoteButton, InlineButton, BlockButton },
      plugins: [rbp],
      hasFocus: false
    };
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { text, reset } = this.props
    if (text !== prevProps.text) {
      if (text === '' || prevProps.text === '' || reset) {
        if (text !== convertToHTML(this.state.text.getCurrentContent())) {
          this.setState({
            text: EditorState.createWithContent(convertFromHTML(text || '')),
          });
        }
      }
    }
  }

  handleTextChange(e) {
    this.setState({ text: e, }, () => {
      this.props.handleTextChange(convertToHTML(this.state.text.getCurrentContent()).replace(/<p><\/p>/g, '<br/>').replace(/&nbsp;/g, '<br/>'));
    });
  }

  render() {
    const { ItalicButton, BoldButton, UnderlineButton, BlockquoteButton, InlineButton, BlockButton} = this.state.components;
    const textBoxClass = this.state.hasFocus ? 'card-content hasFocus' : 'card-content';
    const errorClass = this.props.incompletePrompt ? 'incomplete-prompt' : ''
    const editorFocusClass = this.state.hasFocus ? 'editor-focused' : ''
    const blockquote = this.props.showBlockquote ? <BlockquoteButton><BlockButton className="quote" title="Quote" /></BlockquoteButton> : null
    return (
      <div className={`customize-lessons-editor card is-fullwidth ${errorClass} ${editorFocusClass}`}>
        <div className="buttons-toolbar">
          <div className="buttons-wrapper">
            <BoldButton><InlineButton className="bold" title="Bold" /></BoldButton>
            <ItalicButton><InlineButton className="italic" title="Italic" /></ItalicButton>
            <UnderlineButton><InlineButton className="underline" title="Underline" /></UnderlineButton>
            {blockquote}
          </div>
        </div>
        <div className={textBoxClass}>
          <div className="content">
            <Editor
              ariaLabelledBy={this.props.labelId}
              editorState={this.state.text}
              onBlur={() => this.setState({ hasFocus: false, })}
              onChange={this.handleTextChange}
              onFocus={() => this.setState({ hasFocus: true, })}
              plugins={this.state.plugins}
            />
          </div>
        </div>
      </div>
    );
  }

}

export default MultipleTextEditor;
